// @flow
import React, { Component } from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import OrderTableRow from "./orderTableRow/OrderTableRow";
import OrderBox from "./orderBox/OrderBox";
import { Checkbox } from "../../common";
import styles from "./OrderTable.scss";

const OrderTable = props => {
  const {
    data,
    currencyCode,
    toggleCheckbox,
    selectedOrders,
    indeterminate,
    selectAll,
    allSelected,
    orderStatus,
    browser,
    onAcceptOrder,
    view,
    lang,
    sellerCountry,
    fmIntegrated,
    searchString,
    linkOrder
  } = props;
  const orderList =
    data && !_.isEmpty(data)
      ? data.map((order, index) => (
          <OrderTableRow
            order={order}
            currencyCode={currencyCode}
            key={index}
            sellerCountry={sellerCountry}
            toggleCheckbox={toggleCheckbox}
            selectedOrders={selectedOrders}
            orderStatus={orderStatus}
            onAcceptOrder={onAcceptOrder}
            fmIntegrated={fmIntegrated}
            lang={lang}
            searchString={searchString}
          />
        ))
      : "";
  const orderBox =
    data && !_.isEmpty(data)
      ? data.map((order, index) => (
          <OrderBox
            order={order}
            sellerCountry={sellerCountry}
            currencyCode={currencyCode}
            key={index}
            toggleCheckbox={toggleCheckbox}
            selectedOrders={selectedOrders}
            orderStatus={orderStatus}
            fmIntegrated={fmIntegrated}
            lang={lang}
            onAcceptOrder={onAcceptOrder}
            searchString={searchString}
            linkOrder={linkOrder}
          />
        ))
      : "";

  const unsetFbn = data && data.find(order => order && !order.is_fbn);

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.desktop && view === "grid" ? (
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {fmIntegrated && orderStatus === 2 && unsetFbn ? (
                <th>
                  <Checkbox
                    defaultChecked={allSelected}
                    checked={allSelected}
                    onClick={() => selectAll()}
                    indeterminate={indeterminate}
                    name="head"
                    variant={orderStatus === 3 ? "warning" : ""}
                  />
                </th>
              ) : (
                ""
              )}
              <th>{I18n.getText("order-details.name")}</th>
              <th>{I18n.getText("order-details.item-nr")}</th>
              <th>{I18n.getText("order-details.sku")}</th>
              <th>{I18n.getText("order-details.p-sku")}</th>
              <th>{I18n.getText("order-modal.qty")}</th>
              <th>{I18n.getText("order.order-table-date")}</th>
              <th>{I18n.getText("orders.warehouse")}</th>
              <th>
                {I18n.getText("orders.amount", {
                  currency: I18n.formatCurrency({
                    currency: currencyCode
                  })
                })}
              </th>
              <th>{I18n.getText("order.order-table-status")}</th>
            </tr>
          </thead>
          <tbody>{orderList}</tbody>
        </table>
      ) : (
        <div className={styles.boxCtr}>{orderBox}</div>
      )}
    </div>
  );
};

export default OrderTable;



// WEBPACK FOOTER //
// ./src/components/orders/orderTable/OrderTable.js